import React, { useState } from 'react';
import {
    TextField,
    Button,
    Box,
    IconButton
} from '@mui/material';
import { PhotoCamera } from '@mui/icons-material';
import { roomSettingsService } from '../../../client/room/roomSettingsService';
import toast from 'react-hot-toast';
import { Log, useTranslation } from '@fanfanlo';
import { matrixClient } from '../../../client/client';
import { useProxyWatch } from '@fanfanlo';
import { roomData } from '../../../client/room/data';
const fileLogger = new Log(false, 'im.components.room-settings.BasicSettings');
fileLogger.childrenPaused = true;
fileLogger.pause = true;

export const BasicSettingsContent = ({ roomId }: { roomId: string }) => {
    const logger = fileLogger.sub(false, 'BasicSettings');
    logger.log('props=', { roomId });
    const { t } = useTranslation('homepage/im/components/room-settings/basic/content');
    const [name] = useProxyWatch(roomData.roomSettings.settings, [roomId, 'name'], roomData.roomSettings.settings[roomId]?.name || '')
    const [topic] = useProxyWatch(roomData.roomSettings.settings, [roomId, 'topic'], roomData.roomSettings.settings[roomId]?.topic || '');
    logger.log('name=', name);
    logger.log('topic=', topic);
    const [loading, setLoading] = useState(false);
    const [editData, setEditData] = useState<{ name: string; topic: string } | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        try {
            setLoading(true);
            const newName = editData ? editData.name : name;
            const newTopic = editData ? editData.topic : topic;
            if (newName !== name) {
                await roomSettingsService.updateRoomName(roomId, newName);
            }
            if (newTopic !== topic) {
                await roomSettingsService.updateRoomTopic(roomId, newTopic);
            }
            // TODO: 这里不应该用clientOnEventDispatcher，需要改用imDispatcher，同时侦听的地方也需要换为imDispatcher来侦听。
            // 还有，事件不能用字符串，需要用枚举。
            matrixClient.clientOnEventDispatcher.emit('room.update', roomId);
            toast.success(t('BasicSettings.toast.success'));
            setEditData(null);
        } catch (error: any) {
            toast.error(error.message || t('BasicSettings.toast.error.default'));
        } finally {
            setLoading(false);
        }
    };

    const handleAvatarUpload = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (!file) return;
        try {
            setLoading(true);
            // 这里需要实现文件上传到 Matrix 媒体服务器的逻辑
            // const mxcUrl = await uploadToMatrixMediaServer(file);
            // await roomSettingsService.updateRoomAvatar(roomId, mxcUrl);
            matrixClient.clientOnEventDispatcher.emit('room.update', roomId);
            toast.success(t('BasicSettings.toast.success'));
        } catch (error: any) {
            toast.error(error.message || t('BasicSettings.toast.error.avatar'));
        } finally {
            setLoading(false);
        }
    };

    const getValue = (key: 'name' | 'topic') => {
        if (editData) return editData[key];
        return key === 'name' ? name : topic;
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name: fieldName, value } = e.target;
        setEditData(prev => {
            return {
                name: fieldName === 'name' ? value : (prev?.name ?? name),
                topic: fieldName === 'topic' ? value : (prev?.topic ?? topic)
            };
        });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ '& > *': { mb: 2 } }}>
            <TextField
                fullWidth
                required
                label={t('BasicSettingsContent.form.name.label')}
                name="name"
                value={getValue('name')}
                onChange={handleChange}
                disabled={loading}
            />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, my: 2 }}>
                <input
                    accept="image/*"
                    style={{ display: 'none' }}
                    id="avatar-upload"
                    type="file"
                    onChange={handleAvatarUpload}
                    disabled={loading}
                />
                <label htmlFor="avatar-upload">
                    <IconButton
                        color="primary"
                        component="span"
                        disabled={loading}
                    >
                        <PhotoCamera />
                    </IconButton>
                </label>
            </Box>

            <TextField
                fullWidth
                multiline
                rows={4}
                label={t('BasicSettingsContent.form.topic.label')}
                name="topic"
                value={getValue('topic')}
                onChange={handleChange}
                disabled={loading}
            />

            <Button
                type="submit"
                variant="contained"
                disabled={loading}
                sx={{ mt: 2 }}
            >
                {t('BasicSettingsContent.form.submit')}
            </Button>
        </Box>
    );
}; 